/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Linear_Kb4Inputs */

const en_mk_cmp_linear_kb4 = /** @type {(inputs: Mk_Cmp_Linear_Kb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A formal approval with an action preview and a decision trail.`)
};

const id_mk_cmp_linear_kb4 = /** @type {(inputs: Mk_Cmp_Linear_Kb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approval formal dengan pratinjau aksi dan jejak keputusan.`)
};

/**
* | output |
* | --- |
* | "A formal approval with an action preview and a decision trail." |
*
* @param {Mk_Cmp_Linear_Kb4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_linear_kb4 = /** @type {((inputs?: Mk_Cmp_Linear_Kb4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Linear_Kb4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_linear_kb4(inputs)
	return en_mk_cmp_linear_kb4(inputs)
});